import React, { ReactNode } from 'react'
import {
  FormattedMessage as ReactIntlFormattedMessage,
  IntlFormatters,
  useIntl as useReactIntl
} from 'react-intl'

import type { Props as ReactIntlFormattedMessageProps } from 'react-intl/src/components/message'

import messages from '../dev-translations.json'

export type IntlMessageKeys = keyof typeof messages
type FormatMessageArgs = Parameters<IntlFormatters['formatMessage']>

type FormattedMessageProps = ReactIntlFormattedMessageProps<Record<string, ReactNode>> & {
  id?: IntlMessageKeys
}

export function FormattedMessage({ id, ...rest }: FormattedMessageProps) {
  return <ReactIntlFormattedMessage id={id} {...(rest as any)} />
}

export function useIntl() {
  const { formatMessage, ...rest } = useReactIntl()

  const typedFormatMessage = (
    descriptor: FormatMessageArgs[0] & {
      id?: IntlMessageKeys
    },
    values?: FormatMessageArgs[1],
    options?: FormatMessageArgs[2]
  ) => {
    return formatMessage(descriptor, values as any, options)
  }

  return {
    ...rest,
    formatMessage: typedFormatMessage
  }
}

export { FormattedDate } from 'react-intl'
